// extracted by mini-css-extract-plugin
export default {"bluesnapDiv":"bluesnapDiv--O7_Tb","checkoutDiv":"checkoutDiv--y7cA2"};